/**
 * Health Sync
 *
 * Placeholder component for health data sync.
 */

import { View } from "react-native";

export function HealthSync() {
  return <View />;
}
